/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EsercenteComuneRiferimentoDTO } from './esercente-comune-riferimento-dto';


export interface EsercenteProfiloRowDTO { 
    profilo_id?: string;
    user_id?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    email?: string;
    stato?: EsercenteProfiloRowDTOStatoEnum;
    comune_riferimento?: EsercenteComuneRiferimentoDTO;
    numero_domande?: number;
    anonimizzato_il?: string;
}
export enum EsercenteProfiloRowDTOStatoEnum {
    BLOCCATO_DA_BACKOFFICE = 'BLOCCATO_DA_BACKOFFICE',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_DI_ATTIVAZIONE = 'IN_ATTESA_DI_ATTIVAZIONE',
    ATTIVO = 'ATTIVO'
};



